class TrackProHeader {
  constructor(root) {
    this.root = root;
    this.nav = root.querySelector('[data-header-nav]');
    this.overlay = root.querySelector('[data-header-overlay]');
    this.mobileToggle = root.querySelector('[data-mobile-toggle]');
    this.dropdowns = Array.from(root.querySelectorAll('[data-dropdown]'));
    this.mobileMedia = window.matchMedia('(max-width: 991px)');
    this.scrollLockClass = 'tp-header-scroll-lock';

    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);

    this.bindEvents();
    this.updateHeight();
  }

  bindEvents() {
    if (this.mobileToggle) {
      this.mobileToggle.addEventListener('click', () => {
        this.toggleMobileMenu();
      });
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.closeAll();
      });
    }

    this.dropdowns.forEach((dropdown) => {
      const toggle = dropdown.querySelector('[data-dropdown-toggle]');

      if (!toggle) return;

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggleDropdown(dropdown);
      });
    });

    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onDocumentKeydown);
    window.addEventListener('resize', this.onResize);

    if (typeof this.mobileMedia.addEventListener === 'function') {
      this.mobileMedia.addEventListener('change', this.onMediaChange);
    } else if (typeof this.mobileMedia.addListener === 'function') {
      this.mobileMedia.addListener(this.onMediaChange);
    }
  }

  updateHeight() {
    this.root.style.setProperty('--tp-header-height', `${this.root.offsetHeight}px`);
  }

  onResize() {
    this.updateHeight();
  }

  onMediaChange() {
    this.updateHeight();
    this.closeAll();
  }

  onDocumentClick(event) {
    const openDropdown = this.root.querySelector('.tp-header__dropdown.is-open');
    const clickedMobileToggle = this.mobileToggle && this.mobileToggle.contains(event.target);
    const clickedNav = this.nav && this.nav.contains(event.target);

    if (this.root.classList.contains('is-mobile-open') && !clickedNav && !clickedMobileToggle) {
      this.closeAll();
      return;
    }

    if (openDropdown && !openDropdown.contains(event.target)) {
      this.closeDropdowns();
    }
  }

  onDocumentKeydown(event) {
    if (event.key === 'Escape') {
      this.closeAll();
    }
  }

  toggleMobileMenu(forceState) {
    if (!this.mobileMedia.matches) {
      this.root.classList.remove('is-mobile-open');
      this.setPageScrollLock(false);
      return;
    }

    const shouldOpen =
      typeof forceState === 'boolean' ? forceState : !this.root.classList.contains('is-mobile-open');

    this.root.classList.toggle('is-mobile-open', shouldOpen);
    this.setPageScrollLock(shouldOpen);

    if (this.mobileToggle) {
      this.mobileToggle.setAttribute('aria-expanded', String(shouldOpen));
    }

    this.closeDropdowns();
  }

  setPageScrollLock(locked) {
    document.documentElement.classList.toggle(this.scrollLockClass, locked);
    document.body.classList.toggle(this.scrollLockClass, locked);
  }

  toggleDropdown(targetDropdown) {
    const isOpen = targetDropdown.classList.contains('is-open');
    const isMobile = this.mobileMedia.matches;

    if (isMobile) {
      const toggle = targetDropdown.querySelector('[data-dropdown-toggle]');
      const panel = targetDropdown.querySelector('[data-dropdown-panel]');

      targetDropdown.classList.toggle('is-open', !isOpen);

      if (toggle) {
        toggle.setAttribute('aria-expanded', String(!isOpen));
      }

      if (panel) {
        panel.hidden = isOpen;
      }

      return;
    }

    this.closeDropdowns();

    if (!isOpen) {
      targetDropdown.classList.add('is-open');

      const toggle = targetDropdown.querySelector('[data-dropdown-toggle]');
      const panel = targetDropdown.querySelector('[data-dropdown-panel]');

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
      }

      if (panel) {
        panel.hidden = false;
      }

      this.root.classList.add('has-open-dropdown');
    }
  }

  closeDropdowns() {
    this.dropdowns.forEach((dropdown) => {
      dropdown.classList.remove('is-open');

      const toggle = dropdown.querySelector('[data-dropdown-toggle]');
      const panel = dropdown.querySelector('[data-dropdown-panel]');

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }

      if (panel) {
        panel.hidden = true;
      }
    });

    this.root.classList.remove('has-open-dropdown');
  }

  closeAll() {
    this.toggleMobileMenu(false);
    this.closeDropdowns();
  }
}

document.querySelectorAll('.tp-header-section').forEach((header) => {
  new TrackProHeader(header);
});
